import { createFileRoute } from '@tanstack/react-router'

import { McpPage } from '@/components/Internal/System/McpPage'

export const Route = createFileRoute('/internal/system/administration/mcp')({
  component: McpPage,
})
